import React from "react";
import styles from "./NotificationBar.module.scss";
import Button from "../Button/Button";

export interface INotification {
  id: string;
  type: 'run-off' | 'warning' | 'info' | 'action_required';
  message: string;
  ctaButton?: {
    label: string;
    onClick: () => void;
  };
  dismissible?: boolean;
  onDismiss?: () => void;
  metadata?: any; // For storing run-off details, etc.
}

interface INotificationBarProps {
  notifications: INotification[];
}

const NotificationBar: React.FC<INotificationBarProps> = ({ notifications }) => {
  if (!notifications || notifications.length === 0) {
    return null;
  }

  return (
    <div className={styles.NotificationBar}>
      {notifications.map((notification) => (
        <div key={notification.id} className={`${styles.notification} ${styles[notification.type]}`}>
          <div className={styles.content}>
            <div className={styles.message}>{notification.message}</div>
            {notification.ctaButton && (
              <div className={styles.actions}>
                <Button 
                  className={styles.ctaButton}
                  onClick={notification.ctaButton.onClick}
                >
                  {notification.ctaButton.label}
                </Button>
              </div>
            )}
          </div>
          {notification.dismissible && notification.onDismiss && (
            <button 
              className={styles.dismissButton}
              onClick={notification.onDismiss}
              aria-label="Dismiss notification"
            >
              ×
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default NotificationBar;

